RivalIQ.module('utils.emoji', function (emoji, App, Backbone, Marionette, $, _, twemoji) {

    'use strict';

    const parser = (twemoji || {
        parse: _.identity
    });

    /**
     * Adds detected emoji (as HTML images) to txt.
     */
    emoji.emojify = function (txt) {

        // Only emojify when we're headless (a.k.a., exporting).
        if (!RivalIQ.isHeadless) {
            return txt;
        }

        return (!txt ? '' : parser.parse(txt));
    };

    /**
     * Gets template helpers resolving emoji in views.
     */
    emoji.getTemplateHelpers = function () {

        return _.pick(emoji, 'emojify');
    };

}, window.twemoji);
